import Vue from 'vue'
import router from '../router'
import ApiConfig from './api_config'

export default {
  authenticated: false,
  orgAuthenticated: false,
  user: null,
  userRoles: [],
  token: '',
  getToken() {
    return this.token
  },
  isAuthenticated() {
    return this.authenticated
  },
  isAdmin() {
    return this.user.userName.isAdmin
  },
  id() {
    return this.user !== null ? this.user.userName._id : null
  },
  name() {
    return this.user !== null ? this.user.userName.fullName : null
  },
  email() {
    return this.user !== null ? this.user.userName.email : null
  },
  getUserRoles() {
    return this.user ? this.user.userName.roles : []
  },
  getUser() {
    return this.user.userName
  },
  isReadOnly() {
    return this.user.userName.authorize ? this.user.userName.authorize.id === 2 : false
  },
  async changePassword(data) {
    try {
      console.log('login ', data)
      const res = await Vue.prototype.$http.post(`${ApiConfig.BASE_URL}/user/change-password`, data)
      const result = res.data
      console.log(result)
      if (result.data.accessToken) {
        setTimeout(() => {
          this.logout()
        }, 1500)
        return true
      } else {
        return false
      }
    } catch (error) {
      console.log(error.response)
      //throw error
      return false
    }
  },
  async checkLogin() {
    console.log('checkLogin')
    this.authenticated = window.localStorage.getItem('authenticated')
    // console.log('checkLogin', this.authenticated)
    if (this.authenticated) {
      this.user = JSON.parse(window.localStorage.getItem('user'))
      this.token = this.user.token
    } else {
      console.log('checkLogin failed!')
    }
  },
  async singup(user) {
    try {
      console.log('singup ', user)
      const res = await Vue.prototype.$http.post(`${ApiConfig.BASE_URL}/user/register`, user)
      const result = res.data
      // console.log('singup result', result)
      return result
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  async login(user, password, redirect) {
    try {
      const data = { email: user, password: password }
      console.log('login ', data)
      const res = await Vue.prototype.$http.post(`${ApiConfig.BASE_URL}/user/login`, data)
      const result = res.data
      console.log(result)
      if (result.accessToken) {
        this.authenticated = true
        this.token = result.accessToken
        Vue.prototype.$http.defaults.headers = {
          'Content-Type': 'application/json; charset=utf-8',
          'x-token': this.token,
        }
        // local storelage
        this.user = {
          token: this.token,
          userName: {
            _id: result._id,
            isAdmin: result.isAdmin,
            roles: result.roles,
            fullName: `${result.firstName}  ${result.lastName}`,
            email: result.email,
            farmId: result.farmId,
            authorize: result.authorize
          },
        }
        window.localStorage.setItem('authenticated', true)
        window.localStorage.setItem('user', JSON.stringify(this.user))
        setTimeout(() => {
          router.push(redirect === undefined ? '/' : redirect)
        }, 1000)
      } else {
        return false
      }
      return true
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  logout() {
    window.localStorage.removeItem('authenticated')
    window.localStorage.removeItem('user')
    this.authenticated = false
    this.userRoles = []
    router.go('Login')
  },
  orgLogout() {
    window.localStorage.removeItem('orgAuthenticated')
    window.localStorage.removeItem('orgCode')
    router.go('Login')
  },
}
